import React, { useEffect, useState } from "react"
import CustomSelect from "../../Fields/Select"
import { InputLabel, OutlinedInput, Switch } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import TLServiceComponent from "../../../contexts/TLServiceComponent"
import { MenuItem, Select } from "@material-ui/core"
import siteLanguages from "../../../config/sitelanguages.json"
import FormControl from '@material-ui/core/FormControl'
import config from "../../../config"
import { convertLanguagesToShort, switchStyles, useAutoCompleteStyles } from "../../../utils"
import { useTheme } from "@material-ui/styles"
import { ArrowDropDown } from "@material-ui/icons"

export default function NearTermTabs({ currentTerm,
  setCategoryType, categoryType, setParentId, parentId,
  visibility, setVisibility, setTermLanguage, termLanguage, texttype = false}) {
  const { t, i18n: { language: i18nLanguage } } = useTranslation();
  const { theme: { bgColors, colors } } = useTheme()
  const [categoryName, setCategoryName] = useState();
  const token = useSelector(state => state.userData.token);
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isContrast = themeState !== config.THEMES_MODES.LIGHT
  const selectClasses = useAutoCompleteStyles(bgColors, colors)()
  const classes = switchStyles(bgColors, colors)()

  /**BIND ACTIONS**/
  const tlService = React.useContext(TLServiceComponent);

  function handleOnChangeLanguage(e) {
    const userLanguage = e.target.value;
    if (userLanguage) {
      setTermLanguage(userLanguage)
    }
  }

  const getListTerm = async () => {
    try {
      let terms = await tlService.getFilteredTermCategories(token, {}, {});
      const newArray = terms?.data?.length ? terms.data.map(({ id, name,locale_name }) => {
        return { id, name: `(${id}) ${name[i18nLanguage] || ''}`, locale_name }
      }) : [];
      newArray.unshift({ id: 0, name: t('No parent category') });
      setCategoryName(newArray);
    } catch (e) {
      console.log('error', e)
    }
  }

  // Get list of term category Name:
  useEffect(() => {
    getListTerm()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
 
  const handleChange = (e) => {
    setParentId(e.target.value)
    const parentCatlanguage = categoryName.find(row => row.id === e.target.value)?.locale_name
    setTermLanguage(convertLanguagesToShort(parentCatlanguage) || i18nLanguage)
  }

  return (
    <div className={`d-flex flex-column`} style={{ gridGap: 15 }}>
      <FormControl>
        <Select
          disabled={!!parentId || !!texttype}
          options={[{ id: '1', name: "Deutsch" }, { id: 2, name: "English" },
          ]}
          value={termLanguage}
          onChange={handleOnChangeLanguage}
          input={<OutlinedInput classes={{ root: isContrast ? selectClasses.outlinedRoot : '' }} />}
          IconComponent={(props) => (
            <ArrowDropDown {...props} style={{ color: colors.colorText }} />
          )}
          style={{ backgroundColor: bgColors.bgPrimary200, color: colors.colorText }}
          MenuProps={{
            PaperProps: {
              style: {
                backgroundColor: bgColors.bgPrimary200,
                color: colors.colorText,
                borderRadius: '10px',
              }
            }
          }}
        >
          {
            Object.keys(siteLanguages).map(lang =>
              <MenuItem key={lang} value={lang}>{siteLanguages[lang]['nativeName']}</MenuItem>
            )
          }
        </Select>
      </FormControl>
      {!texttype && <>
      <CustomSelect label={t('category_type')}
        options={
          config.categoryTypeList
        }
        value={categoryType}
        handleChange={e => setCategoryType(e.target.value)}
      />
      <div>
        <Switch label={'Visibility (will the category visible to all users?)'} onChange={e => setVisibility(!visibility)}
          checked={visibility} className={classes.root}
        /> {t('visibility-to-user')}
      </div>
      {!!currentTerm ? <CustomSelect disabled label={t('Parent Category')} value={parentId}
        options={
          categoryName?.length ? categoryName : []
        } /> :
        <CustomSelect label={t('Parent Category')} handleChange={handleChange} value={parentId}
          options={
            categoryName?.length ? categoryName : []
          } />
      }
      </>}
    </div>
  )
}
